/*
 * @Author: mawencan
 * @Date: 2020-11-26 16:43:59
 * @Last Modified by: mawencan
 * @Last Modified time: 2021-01-20 10:42:33
 * @Explain 用来复用-用户鲸币
 */
import { getUserCoinInfo } from '@/api/fundsManage'

export default {
  data () {
    return {
      userCoinInfo: {
        yxl_coin: 0, //鲸币余额
        money_status: 0,
        income_coin: 0, //账户剩余收入鲸币，可提现鲸币
        consume_coin: 0, //累计消费鲸币
        account_type: 0, //账号类型，0普通用户，1内部用户
        withdrawa_coin: { //提现鲸币，have_withdrawal + no_withdrawal = 累计收入记录
          have_withdrawal: 0, //已经提现鲸币,
          no_withdrawal: 0, //未提现鲸币
        }, //可提现鲸币,
        recharge_coin_total: 0, // 累计充值鲸币
        recharge_coin: 0, // 充值剩余鲸币
        consume_coin_info: {
          yxl_coin: 0, // 总累计消费鲸币
          giving_coin: 0, // 赠送部分消费鲸币
          income_coin: 0, // 收入消费鲸币
          recharge_coin: 0, // 充值消费鲸币
        }
      }
    }
  },
  computed: {
    // 鲸币余额
    balance () {
      return this.getNumberDefault(this.userCoinInfo.yxl_coin)
    },
    // 累计收入记录
    totalWithdrawa () {
      const {
        withdrawa_coin
      } = this.userCoinInfo
      const num = withdrawa_coin.have_withdrawal + withdrawa_coin.no_withdrawal
      return this.getNumberDefault(num)
    }
  },
  methods: {
    async getUserCoinInfo () {
      try {
        const { data: resData } = await getUserCoinInfo()
        this.userCoinInfo = resData.data
      } catch (e) {
        console.error(e)
      }
    },
    getNumberDefault (num) {
      return isNaN(num) ? 0 : num
    }
  }
}
